import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ChecklistComponent, PrimaryButtonComponent } from '@tran-monorepo/frontend/components';
import { ContentSectionComponent } from '../../../../shared/components/custom';

@Component({
    selector: 'tran-customer-home-clustered-tiles-section',
    imports: [TranslatePipe, ContentSectionComponent, PrimaryButtonComponent, ChecklistComponent],
    templateUrl: './clustered-tiles-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClusteredTilesSectionComponent {
    protected readonly HOME_CHECKLIST = [
        'home.transformation-funds.checklist.item1',
        'home.transformation-funds.checklist.item2',
        'home.transformation-funds.checklist.item3',
        'home.transformation-funds.checklist.item4'
    ];
}
